import React, { useState, useRef, createContext, useContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Login } from './Login';
interface AuthContextValue {
  isAuthenticated: boolean;
  // Run `action` if signed in; otherwise prompt registration and run it after.
  requireAuth: (action?: () => void) => void;
  openLogin: () => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextValue | null>(null);
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);
  const requireAuth = (action?: () => void) => {
    if (isAuthenticated) {
      action?.();
      return;
    }
    pendingAction.current = action ?? null;
    setIsLoginOpen(true);
  };
  const openLogin = () => {
    pendingAction.current = null;
    setIsLoginOpen(true);
  };
  const completeLogin = () => {
    setIsAuthenticated(true);
    setIsLoginOpen(false);
    const action = pendingAction.current;
    pendingAction.current = null;
    // Run the gated action shortly after the modal closes
    if (action) setTimeout(action, 150);
  };
  const logout = () => setIsAuthenticated(false);
  return <AuthContext.Provider value={{
    isAuthenticated,
    requireAuth,
    openLogin,
    logout
  }} data-id="element-84" data-mp="o66lbgvs63w5">
      {children}
      <AnimatePresence data-id="element-85" data-mp="fewh8vn4upd7">
        {isLoginOpen && <Login onLogin={completeLogin} onClose={() => {
        pendingAction.current = null;
        setIsLoginOpen(false);
      }} data-id="element-86" data-mp="fdlemz5fbnno" />}
      </AnimatePresence>
    </AuthContext.Provider>;
}